import { ACCENT_COLOR_HOVER, ACCENT_COLOR_MAIN } from "config/constants";

export const colors = {
  text: {
    primary: "#2D2D2D",
    secondary: "#8A8A8A",
  },
  accents: {
    main: ACCENT_COLOR_MAIN,
    hover: ACCENT_COLOR_HOVER,
    loader: "#2951a1",
  },
  background: {
    default: "#FFFFFF",
    secondary: "#0000000a",
    hover: "#eeeeee",
    modalBg: "#f5f8fa",
    button: "#ebeff2",
  },
  gray: {
    main: "#6E6E6E",
    disabled: "#B9B9B9",
    btnBorder: "#d0d5d9",
  },
  green: {
    main: "#3d9b41",
    hover: "#73b476",
    itemHover: "#c4ebc8",
  },
  error: {
    main: "#c4271e",
    hover: "#dc4844",
  },
};
